<app-dea-dialog-wrapper>
  <div style="max-height: max(75vh, 400px); overflow-y: auto;">
    <div class="dea-fake-table-row-header row m-0 p-0 row-cols-4 sticky-top bg-white"
      style="border-bottom: 1px solid rgba(0,0,0,0.1);">
      <div scope="col m-0 p-0" style="width: 48px !important;"></div>
      <div scope="col">Cognome</div>
      <div scope="col">Nome</div>
      <div scope="col">Secondo Nome</div>
    </div>
    <div *ngFor="let user of users;"
      class="user-listing-table-row dea-radius dea-table-row-hover-bg row m-0 p-0 row-cols-4">
      <div class="col m-0 d-flex align-items-center" style="width: 48px !important;" title="{{user?.getFullName()}}">
        <mat-checkbox color="primary" [labelPosition]="'before'" [checked]="isChecked(user?.id)"
          (change)="onChangeCheckbox(user?.id)">
        </mat-checkbox>
      </div>
      <div class="col m-0 d-flex align-items-center" title="{{user?.getFullName()}}"
        (change)="onChangeCheckbox(user?.id)">
        <div>{{user?.cognome}}</div>
      </div>
      <div class="col m-0 d-flex align-items-center" title="{{user?.getFullName()}}"
        (change)="onChangeCheckbox(user?.id)">
        <div>{{user?.nome}}</div>
      </div>
      <div class="col m-0 d-flex align-items-center" title="{{user?.getFullName()}}"
        (change)="onChangeCheckbox(user?.id)">
        <div>{{user?.secondo_nome}}</div>
      </div>
    </div>
  </div>
  <div class="mt-4 gap-2" mat-dialog-actions align="end">
    <div class="me-auto opacity-75">Selezionati: {{selectedUsersLength}}</div>
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">
      Annulla
    </button>
    <button class="px-5 py-1" mat-flat-button (click)="onConfirm()" color="primary">
      Conferma Selezione
    </button>
  </div>
</app-dea-dialog-wrapper>